import { postAzureResourceGraph } from './azureApi';
import { createApiInstance } from './index';
import { getProjectContext, withProjectContext } from './projectContext';

const gcpApi = createApiInstance();

export const postGcpResourceGraph = async (payload = {}) => {
  const { project_uuid } = getProjectContext();
  if (!project_uuid) {
    throw new Error('找不到有效的 project_uuid，請先選擇專案');
  }

  const response = await gcpApi.post('gcp-resource-graph/', withProjectContext(payload));
  return response.data;
};

export const postAwsResourceGraph = async (payload = {}) => {
  const { project_uuid } = getProjectContext();
  if (!project_uuid) {
    throw new Error('找不到有效的 project_uuid，請先選擇專案');
  }

  const response = await gcpApi.post('aws-resource-graph/', withProjectContext(payload));
  return response.data;
};

export const postComplianceResourceGraph = async ({ platform = 'azure', payload = {} } = {}) => {
  if (platform === 'gcp') {
    return postGcpResourceGraph(payload);
  }
  if (platform === 'aws') {
    return postAwsResourceGraph(payload);
  }
  return postAzureResourceGraph(payload);
};
